import React from 'react'
import { Backdrop, CircularProgress } from '@material-ui/core'

import PropTypes from 'prop-types'

const LoaderBackdrop = ({ loading }) => {
  return (
    loading && (
      <Backdrop open={loading} style={{ zIndex: 99999 }}>
        <CircularProgress />
      </Backdrop>
    )
  )
}
export default LoaderBackdrop
LoaderBackdrop.propTypes = {
  loading: PropTypes.bool
}
